module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper",
    class: {
      hideSidebar: !_vm.sidebar.opened
    }
  }, [_c('linkbar'), _vm._v(" "), _c('div', {
    staticClass: "sidebar-wrapper"
  }, [_c('Sidebar', {
    staticClass: "sidebar-container"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('navbar'), _vm._v(" "), _c('app-main')], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-91abd114", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91abd114"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Layout.vue
// module id = 318
// module chunks = 88